import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  coins: 0,
};

const walletSlice = createSlice({
  name: "wallet",
  initialState,
  reducers: {
    walletAmount: (state, action) => {
      state.coins = action.payload;
    },
  },
});

export default walletSlice.reducer;
export const { walletAmount } = walletSlice.actions;
